import React from 'react'
import { Grid } from "@mui/material"
import { AppFormSection } from "@components"

import {
	AlertsBaseDrawer,
	AlertsComparisonType,
	AlertsConditionName,
	AlertsDrawerBaseFooter,
	AlertsMoreFeatures
} from "Pages/ReportsAlerts/Alerts/Conditions/@components"
import AlertsMainSites from "Pages/ReportsAlerts/Alerts/Conditions/NoAvailability/Drawer/MainSites"
import Providers from "Pages/ReportsAlerts/Alerts/Conditions/NoAvailability/Drawer/Providers"
import NotifyAvailability from "Pages/ReportsAlerts/Alerts/Conditions/NoAvailability/Drawer/NotifyAvailability"


export default function NoAvailabilityDrawer({ onSubmitAlert, isLoading }) {

	return <AlertsBaseDrawer
		footer={<AlertsDrawerBaseFooter isLoading={isLoading} onSubmitAlert={onSubmitAlert}/>}
		content={<>
			<AppFormSection icon="tag" title="Condition">
				<Grid container spacing={2}>
				<Grid item xs={12} data-tour-id="cond-na-name">
					<AlertsConditionName/>
				</Grid>
				</Grid>
			</AppFormSection>
			<AppFormSection icon="location-dot" title="Main site">
				<Grid container spacing={2}>
				<Grid item xs={12} data-tour-id="cond-na-main-site">
					<AlertsMainSites/>
				</Grid>
				<Grid item xs={12}/>
				<Grid item xs={12} data-tour-id="cond-na-providers">
					<Providers providersLabel="Providers not available" tiersLabel="Tiers not available"/>
				</Grid>
				</Grid>
			</AppFormSection>
			<AppFormSection icon="scale-balanced" title="Comparison">
				<Grid container spacing={2}>
				<Grid item xs={12} data-tour-id="cond-na-comp-type">
					<AlertsComparisonType/>
				</Grid>
				</Grid>
			</AppFormSection>
			<AppFormSection icon="bell" title="Notification">
				<Grid container spacing={2}>
				<Grid item xs={12} data-tour-id="cond-na-notify">
					<NotifyAvailability/>
				</Grid>
				</Grid>
			</AppFormSection>
			<AppFormSection icon="sliders" title="More features" hint="optional">
				<Grid container spacing={2}>
				<Grid item xs={12} data-tour-id="cond-na-more">
					<AlertsMoreFeatures/>
				</Grid>
				</Grid>
			</AppFormSection>
		</>}
	/>
}